import { useEffect, useState } from 'react';

const useCountdown = (
  from: number,
  to: number,
  active: boolean,
  onComplete: () => void,
) => {
  const [value, setValue] = useState(from);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    let timer: number | undefined;
    if (!active && timer != null) {
      window.clearTimeout(timer);
    } else if (active && value !== to) {
      timer = window.setTimeout(() => {
        setValue(value => value - 1);
      }, 1000);
    }
    return () => window.clearTimeout(timer);
  }, [active, to, value]);

  useEffect(() => {
    if (value === to && !completed) {
      setCompleted(true);
      onComplete();
    }
  }, [value, to, onComplete, completed]);

  return value;
};

export default useCountdown;
